(function () {
  function updateVisibility(wrap, content, toggle) {
    if (wrap.classList.contains('is-expanded')) return;
    toggle.hidden = content.scrollHeight <= content.clientHeight + 1;
  }

  function bind(wrap) {
    if (wrap.dataset.wsOverviewBound) return;
    wrap.dataset.wsOverviewBound = 'true';

    var content = wrap.querySelector('[data-ws-overview-text-content]');
    var toggle = wrap.parentNode.querySelector('[data-ws-overview-toggle]');
    if (!content || !toggle) return;

    var moreLabel = toggle.querySelector('[data-ws-overview-toggle-more]');
    var lessLabel = toggle.querySelector('[data-ws-overview-toggle-less]');

    updateVisibility(wrap, content, toggle);
    window.addEventListener('resize', function () {
      updateVisibility(wrap, content, toggle);
    });

    toggle.addEventListener('click', function () {
      var expanding = !wrap.classList.contains('is-expanded');
      wrap.classList.toggle('is-expanded', expanding);
      if (moreLabel) moreLabel.hidden = expanding;
      if (lessLabel) lessLabel.hidden = !expanding;
      if (!expanding) updateVisibility(wrap, content, toggle);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ws-overview-text]').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
